import { render, staticRenderFns } from "./BackToTheTop.vue?vue&type=template&id=7208a8e3&scoped=true&"
import script from "./BackToTheTop.vue?vue&type=script&lang=js&"
export * from "./BackToTheTop.vue?vue&type=script&lang=js&"
import style0 from "./BackToTheTop.vue?vue&type=style&index=0&id=7208a8e3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7208a8e3",
  null
  
)

component.options.__file = "BackToTheTop.vue"
export default component.exports